import routeConfig from 'edge/fnol/wc/config/RouteConfig';
import MedicalTreatmentComponent from 'edge/fnol/wc/components/MedicalTreatment/MedicalTreatmentComponent';
import InjuryDetailsComponent from 'edge/fnol/wc/components/InjuryDetails/InjuryDetailsComponent';

import 'edge/fnol/common/app';

export default angular.module('edge.fnol.wc.app', ['edge.fnol.common.app']).config(['$stateProvider', 'state_plugin_config', function ($stateProvider, RootStateConfig) {
    var states = routeConfig(RootStateConfig);
    for (var stateName in states) {
        if (states.hasOwnProperty(stateName)) {
            $stateProvider.state(stateName, states[stateName]);
        }
    }
}]).component('gwFnolWcMedicalTreatment', MedicalTreatmentComponent).component('gwFnolWcInjuryDetails', InjuryDetailsComponent);